import React, { useEffect,useRef, useState } from 'react';
import {Card,Table,Space,Modal,Button,Form,Input,Row,Col,message,Descriptions,Tabs,Select,InputNumber,DatePicker,Typography
} from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import { InvoiceNumReq } from '@gtpl/shared-models/raw-material-procurement';
import { Link } from 'react-router-dom';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
const { RangePicker } = DatePicker;

const { Title } = Typography;

interface InvoiceItem {
  invNum: string;
  grnId: number;
  voucherNo: string;
  farmerId: number;
  farmerName: string;
  quantity: string;
  price: string;
  amount: string;
}

interface InvoiceData {
  invNum: string;
  invDate: string;
 quantity: string;
  amount: string;
  farmerName: string;
  items: InvoiceItem[];
}

export const RmVoucherPoView = () => {
  const [form] = Form.useForm();
  const [data, setData] = useState<InvoiceData[]>([]);
  const [invNum, setInvNum] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
     const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const services = new RMGrnService();

  useEffect(() => {
    getAllInvoiceNumbers();
    getInvoiceDetails();
  }, []);
  const getAllInvoiceNumbers = () => {

    services
      .getAllInvoiceNumbers()
      .then((res: any) => {
        if (res.status) {
          setInvNum(res.data || []);
        } else {
          setInvNum([]);
          message.error(res.internalMessage || 'No data found');
        }

        setLoading(false);
      })
      .catch(() => {
        setInvNum([]);
        message.error('Something went wrong');
        setLoading(false);
      });
  };

        function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
     const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });
  const getInvoiceDetails = () => {
    setLoading(true);

    const req = new InvoiceNumReq();

    const invNum = form.getFieldValue('invNum');
    const invDate = form.getFieldValue('invDate');

    if (invNum) {
      req.invNo = invNum;
    }

    if (form.getFieldValue('invDate') && form.getFieldValue('invDate')[0]) {
      req.fromDate = (form.getFieldValue('invDate')[0]).format('YYYY-MM-DD');
      req.toDate = (form.getFieldValue('invDate')[1]).format('YYYY-MM-DD');
    }

    services
      .getInvoiceDetails(req)
      .then((res: any) => {
        if (res.status) {
          setData(res.data || []);
        } else {
          setData([]);
          message.error(res.internalMessage || 'No data found');
        }

        setLoading(false);
      })
      .catch((err: any) => {
        console.error(err);
        setData([]);
        message.error('Something went wrong');
        setLoading(false);
      });
  };

  const onFinish = () => {
    getInvoiceDetails();
  };
  const onReset = () => {
    form.resetFields();
    getInvoiceDetails();
  }

  const columns: ColumnsType<InvoiceData> = [
    {
      title: 'S.No',
      key: 'index',
      width: 70,
      align: 'center',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Invoice No',
      dataIndex: 'invNum',
      key: 'invNum',
      sorter: (a, b) => (a.invNum || '').localeCompare(b.invNum || ''),
      ...getColumnSearchProps('invNum'),
    },
    {
      title: 'Invoice Date',
      dataIndex: 'invDate',
      key: 'invDate',
      render: (value: string) =>
        value ? dayjs(value).format('DD-MM-YYYY') : '-',
      sorter: (a, b) => (a.invDate || '').localeCompare(b.invDate || ''),
      ...getColumnSearchProps('invDate'),
    },

    {
      title: 'Farmer Name',
      dataIndex: 'farmerName',
      key: 'farmerName',
      sorter: (a, b) => (a.farmerName || '').localeCompare(b.farmerName || ''),
      ...getColumnSearchProps('farmerName'),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'left',
      render: (value: string) => Number(value).toLocaleString(),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'left',
      render: (value: string) =>
        `₹ ${Number(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
  ];
  const itemColumns: ColumnsType<InvoiceItem> = [
  {
    title: 'S.No',
    render: (_, __, index) => index + 1,
    width: 70,
    align: 'center',
  },
  {
    title: 'Voucher No',
    dataIndex: 'voucherNo',
  },
  {
    title: 'Farmer Name',
    dataIndex: 'farmerName',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    render: (value: string) => Number(value).toLocaleString(),
  },
  {
    title: 'Price',
    dataIndex: 'price',
    render: (value: string) =>
      `${Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    render: (value: string) =>
      `₹ ${Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
  },
];
  const totalQuantity = data.reduce(
    (sum, item) => sum + Number(item.quantity || 0),
    0
  );

  const totalAmount = data.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  );

  return (
    <Card
      title={<span style={{ color: 'white' }}>RM Vendor PO View</span>}
      style={{ margin: 20 }}
      headStyle={{
        backgroundColor: '#69c0ff',
        border: 0,
        textAlign: 'center',
      }}
      extra={
        <Link to="/rm-vendor-po">
          <Button type="default">Create</Button>
        </Link>
      }
    >
      
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Invoice No"
              name="invNum"
            >
              <Select
                placeholder="Select Invoice"
                allowClear
              >
                {invNum.map((item: any) => (
                  <Select.Option
                    key={item.invNum}
                    value={item.invNum}
                  >
                    {item.invNum}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="Invoice Date"
              name="invDate"
            >
              <RangePicker
                style={{ width: '100%' }}
                format="DD-MM-YYYY"
              />
            </Form.Item>
          </Col>

          <Col
            span={4}
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Search
      </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
              Reset
            </Button>
          </Col>
        </Row>
      </Form>
      <Table
        bordered
        rowKey="invNum"
        columns={columns}
        dataSource={data}
        loading={loading}
        scroll={{ x: 'max-content' }}
        expandable={{
 expandedRowRender: (record) => (
  <div style={{ padding: 12, background: "#fff" }}>
    <Table
      columns={itemColumns}
      dataSource={record.items}
      rowKey="grnId"
      pagination={false}
      size="small"
      showHeader
    />
  </div>
),
}}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
        }}
        summary={() => (
          <Table.Summary fixed>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={5}>
                <strong>Grand Total</strong>
              </Table.Summary.Cell>

              <Table.Summary.Cell index={1} align="left">
                <strong>{totalQuantity.toLocaleString()}</strong>
              </Table.Summary.Cell>

              <Table.Summary.Cell index={2} align="left">
                <strong>
                  ₹{' '}
                  {totalAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
      />
    </Card>
  );
};

export default RmVoucherPoView;